module.exports = __webpack_public_path__ + "img/poker-s10.9a27f484.svg";